import type { UserPreferencesProvider as UserPreferencesProviderNext } from '@atlaskit/editor-common/user-preferences-provider';
import type { UserPreferencesPluginOptions } from '@atlaskit/editor-plugin-user-preferences/user-preferences-plugin-type';

interface Props {
	providers: {
		userPreferencesProviderNext?: UserPreferencesProviderNext;
	};
}

export function userPreferencesPluginOptions({ providers }: Props): UserPreferencesPluginOptions {
	return {
		userPreferencesProvider: providers.userPreferencesProviderNext,
		initialUserPreferences: undefined, // This will be set by the userPreferencesProvider if available;
	};
}
